var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activityInProgress)?_c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"title":"Add key moment"},on:{"click":_vm.addKeyMoment}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faCommentPlus}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-156e37e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CallInfo/AddKeyMomentButton.vue
// module id = WmS5
// module chunks = 1